export const getContainerModal = (id: string): HTMLElement => document.querySelector(`#${id}`) as HTMLElement;
